new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        videoSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if(contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        getInfo(event, id) {
            axios.get(`/api/front/product/${id}/get-linked-product/`)
            .then(res => {
                const actualElement = event.target;
                if ($('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').length) {
                    $('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').remove();
                }
                actualElement.closest('.product-item-kit').querySelector('.is-selected')?.classList.remove('is-selected');
                actualElement.closest('.product-item-kit').querySelector('.is-selected')?.classList.add('is-selected');
                actualElement.closest('.product-item-kit').setAttribute('data-product-item-kit-id', res.data.id);   
                actualElement.closest('.product__colors-item').classList.add('is-selected');
                actualElement.closest('.product-item-kit').querySelector('.name span').innerHTML = `${res.data.name}`;
                actualElement.closest('.product-item-kit').querySelector('.name img').src = `${res.data.thumbnail}`;
                const actualVariations = actualElement.closest('.product-item-kit').nextElementSibling;
                actualVariations.innerHTML = '<p class="label_attributes">Selecione o tamanho</p>';
                var sizes = [];
                for (i = 0; i <= res.data.variations.length - 1; i++) {
                    if (res.data.variations[i].main_attribute != null) {
                        sizes.splice(res.data.variations[i].main_attribute.order, 0, res.data.variations[i]);
                    }
                }
                for (i = 0; i <= sizes.length - 1; i++) {
                    if (sizes[i].main_attribute != null) {
                        var randomNumber = Math.floor(Math.random() * 99999999);
                        var stock = sizes[i].available == false ? 'out-of-stock' : '';
                        actualVariations.insertAdjacentHTML('beforeend', `<input type="radio" name="product_item_variation__product_detail__${res.data.id}_${randomNumber}" id="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" value="${sizes[i].id}" data-id-auto="" data-variation-name="${sizes[i].main_attribute.name}" data-origin-location="product_detail"><label for="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" class="label_radio ${stock} radio"><span>${sizes[i].main_attribute.value}</span></label>`);
                    }
                }
                if (res.data.addons.length) {
                    var complements = document.createElement('div');
                    complements.setAttribute('id', `js-product_addons__product_detail_${id}`);
                    complements.setAttribute('class', 'complements');
                    complements.setAttribute('complements-for', `${id}`);
                    complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>';
                    for (i = 0; i <= res.data.addons.length - 1; i++) {
                        var optional = res.data.addons[i].is_required == false ? 'True' : 'False';
                        var addonPrice = res.data.addons[i].price ? res.data.addons[i].price : '';
                        complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${res.data.addons[i].id}" addon-id="${res.data.addons[i].id}" addon-price="${addonPrice}" for="addon-${res.data.addons[i].id}" data-addon-is-optional="${optional}">${res.data.addons[i].field_label}</label>`);
                        if (res.data.addons[i].field_type == "radio_options") {
                            var complementsSelect = document.createElement('select');
                            complementsSelect.setAttribute('name', `addon-${res.data.addons[i].id}`);
                            complementsSelect.setAttribute('id', `addon-select-${res.data.addons[i].id}`);
                            for (j = 0; j <= res.data.addons[i].field_options.length - 1; j++) {
                                complementsSelect.add(new Option(`${res.data.addons[i].field_options[j]}`, `${res.data.addons[i].field_options[j]}`));
                            }
                            var selectDiv = document.createElement('div');
                            selectDiv.setAttribute('class', 'complements-content');
                            $(selectDiv).append(complementsSelect);
                            $(complements).append(selectDiv);
                        } else if (res.data.addons[i].field_type == "text") {
                            var selectDiv = document.createElement('div');
                            selectDiv.setAttribute('class', 'complements-content-area');
                            $(selectDiv).append(`<input name="addon-${res.data.addons[i].id}" type="${res.data.addons[i].field_type}" maxlength="${res.data.addons[i].field_char_limit}"></div>`);
                            $(complements).append(selectDiv);
                        }
                    }
                    $('.kitcolors').closest('.itens-for-carousel').append(complements);
                }
                $('.kitcolors').height($('.kitcolors').closest('.itens-for-carousel').outerHeight());
                $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').on('change', function() {
                    $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').not(this).prop('checked', false);  
                });
                if (window.outerWidth <= 991) {
                    var slickSlider = $('.product-detail__header--photoArea-mobile');

                    if (slickSlider.hasClass('slick-initialized')) {
                        slickSlider.slick('slickRemove', null, null, true);
                    } else {
                        slickSlider.slick();
                    }
                
                    for (i = 0; i < res.data.images.length; i++) {
                        slickSlider.slick('slickAdd', `<li><a href="${res.data.images[i]}" data-fancybox="gallery3"><img class="product-detail__header--photoArea-mobile-img" src="${res.data.images[i]}" width="100%"></a></li>`);
                    }
                
                    slickSlider.slick('slickGoTo', 1);
                } else {
                    const noThumbs = document.querySelector('#product-photo');
                    if (noThumbs) {
                        var noThumbsUl = document.querySelector('#product-photo ul');

                        // Remova todos os spans dentro do noThumbsUl
                        while (noThumbsUl.firstChild) {
                            noThumbsUl.removeChild(noThumbsUl.firstChild);
                        }

                        for (i = 0; i <= res.data.images.length - 1; i++) {
                            var li = document.createElement('li');
                            li.innerHTML = `<a href="${res.data.images[i]}" data-fancybox="gallery1"><img src="${res.data.images[i]}" width="100%"></a>`;
                            noThumbsUl.appendChild(li);
                        }
                    } else {
                        $('.sp-wrap').each(function() {
                            $(this).closest('.slick-slide').remove();
                        });
                        for (i = 0; i <= res.data.images.length - 1; i++) {
                            $('.sp-thumbs').slick('slickAdd', `<div><a class="sp-wrap" href="${res.data.images[i]}" style="background-image: url(${res.data.images[i]}); width: 100%; display: inline-block;" tabindex="0" data-video="undefined"><img src="${res.data.images[i]}" width="100%"></a></div>`, i);
                            if (i == 0) {
                                document.querySelector('.sp-wrap').click();
                            }
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if(photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');
    
                    if(photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');
    
                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                              content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }
        
                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                              activeTab(index);
                            });
                        });
                    }
                }
            }

            if(photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) { 
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 4,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }else if (photoThumbs.classList.contains('gallery-bottom')) {
                    
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 4,
                        vertical: false,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.isVideo = false;
            this.imgSrc = src;
        },
        updateVideoThumb(src) {
            this.imgSrc = false;
            this.isVideo = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();
            
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
            const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.resizeThumbs();
        this.clickThumbs();

        waitForElementToExist('.price-cupom').then(element => {
            const priceCupom = document.querySelector('.price-cupom b');

            if (priceCupom) {
                const priceCupomValue = priceCupom.textContent;

                if (priceCupomValue) {
                    let newValue = priceCupomValue;

                    if (priceCupom) {
                        priceCupom.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });

        waitForElementToExist('.product-detail-faq').then(element => { 
            const productDetailFaqListItems = document.querySelectorAll('.product-detail-faq-list-item');

            if(productDetailFaqListItems.length) {
                productDetailFaqListItems[0].classList.add('active');

                function activeTab(index) {
                    productDetailFaqListItems.forEach((content) => {
                        content.classList.remove('active');
                    });
                    productDetailFaqListItems[index].classList.add('active');
                }

                productDetailFaqListItems.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        activeTab(index);
                    });
                });
            }
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if(ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                    ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
    }
})

$(document).ready(function () {

      // Função para verificar se todos os itens do kit têm tamanhos selecionados
      function checkAllKitItemsHaveSizes() {
        const allKitItems = document.querySelectorAll('.itens-for-carousel .js_product_item_kit');

        // Verifica se existem itens do kit
        if (!allKitItems || allKitItems.length === 0) {
            return true; // Se não há itens do kit, considera como válido
        }

        let allItemsHaveSizes = true;

        allKitItems.forEach(function (item) {
            const hasVariations = item.getAttribute('data-no-variations');
            if (!hasVariations) {
                // Procura pela variação de rádio no mesmo slide
                const slide = item.closest('.itens-for-carousel');
                const radioVariation = slide.querySelector('.product-radio-variation');
                if (radioVariation) {
                    const checkedInput = radioVariation.querySelector('input[type="radio"]:checked');
                    if (!checkedInput) {
                        allItemsHaveSizes = false;
                    }
                } else {
                    allItemsHaveSizes = false;
                }
            }
        });

        return allItemsHaveSizes;
    }

    // Função para atualizar o estado do botão de compra
    function updateAddToCartButtonState() {
        const addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        if (addToCartButton) {
            const allItemsHaveSizes = checkAllKitItemsHaveSizes();

            if (allItemsHaveSizes) {
                addToCartButton.classList.remove('no-buy');
            } else {
                addToCartButton.classList.add('no-buy');
            }
        }
    }

    // Listener para quando um tamanho é selecionado
    $(document).on('change', '.product-radio-variation input[type="radio"]', function() {
        updateAddToCartButtonState();
    });

    let description = document.querySelector('.description-nav');
    if (description) {
        let navTab = description.querySelectorAll('.nav-item');
        let navShow = description.querySelectorAll('.description-nav-content');
        navTab = Array.from(navTab);
        navShow = Array.from(navShow);

        if (navTab.length && navShow.length) {
            navTab[0].classList.add('active');
            navShow[0].classList.add('active');

            function activeTab(index) {
                navTab.forEach((content) => {
                    content.classList.remove('active');
                });
                navTab[index].classList.add('active');
                navShow.forEach((content) => {
                    content.classList.remove('active');
                });
                navShow[index].classList.add('active');
            }

            navTab.forEach((itemMenu, index) => {
                itemMenu.addEventListener('click', () => {
                    activeTab(index);
                });
            });
        }
    }

    waitForElementToExist('.carousel-kit').then(element => {
        const carouselKit = document.querySelector('.carousel-kit');
        if (carouselKit) {
            const intensForCarousel = document.querySelectorAll('.itens-for-carousel');
            if (intensForCarousel.length) {
                const firstKit = intensForCarousel[0].querySelector('#kitcolors0 figure');
                if (firstKit) {
                    firstKit.click();
                }
            }
        }
    });

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            height: "auto",
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
            addToCartButton.classList.add('no-buy');

            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-actual') {
                    var actual = parseInt(nextButton.getAttribute('data-actual'));
                    var end = parseInt(nextButton.getAttribute('data-end'));
                    
                    if (actual === end) {
                        nextButton.classList.add('no-click');
                    } else {
                        nextButton.classList.remove('no-click');
                    }
                }
            });
        });
        
        // Configurar o observer para monitorar mudanças no atributo data-actual
        observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['data-actual']
        });
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
                
                // Verifica se há input selecionado no slide atual e adiciona no-buy se não houver
                var activeSlide = document.querySelector('.splide__slide.is-active');
                if (activeSlide) {
                    var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                    var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');
                    
                    if (!radioChecked && !noVariations) {
                        addToCartButton.classList.add('no-buy');
                    }
                }
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
            
            // Verifica se há input selecionado no slide atual após o movimento
            var activeSlide = document.querySelector('.splide__slide.is-active');
            if (activeSlide) {
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');
                
                if (!radioChecked && !noVariations) {
                    addToCartButton.classList.add('no-buy');
                }
            }
        });
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });
        
        observer.observe(brinde, {
            childList: true,
            subtree: true
        });
        
    }

    var $mobileSlider = $('.product-detail__header--photoArea-mobile');
    if ($mobileSlider.length) {
        $mobileSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });

        $mobileSlider.find('img').each(function() {
            var img = this;
            if (img.complete) {
                $mobileSlider.slick('setPosition');
            } else {
                img.addEventListener('load', function() {
                    $mobileSlider.slick('setPosition');
                });
                img.addEventListener('error', function() {
                    $mobileSlider.slick('setPosition');
                });
            }
        });
    }

    if($('#like-carousel')) {
        $('#like-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            prevArrow: $(".product-list-arrows .prev"),
            nextArrow: $(".product-list-arrows .next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        dots: false,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1249,
                    settings: {
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    
        $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function(element) {
                    setTimeout(function(){
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();
    
    // Controles customizados para #photo-list
    function getBaseItems($slider){
        return $slider.find('li').not('.slick-cloned');
    }
    function normalizeIndex(index, total){
        if(!total) return 0; return ((index % total) + total) % total;
    }
    // Navegação custom: calcula próximo/anterior com base no item .active (não clonado)

    // $(document).on('click', '.custom-next-arrow', function(e){
    //     e.preventDefault();
    //     var $slider = $('#photo-list');
    //     if(!$slider.length) return;
    //     var $baseItems = getBaseItems($slider);
    //     if(!$baseItems.length) return;
    //     var total = $baseItems.length;
    //     var $current = $baseItems.filter('.active').first();
    //     var currentIdx = parseInt($current.attr('data-slick-index'), 10);
    //     if(isNaN(currentIdx)) currentIdx = 0;
    //     var nextIdx = normalizeIndex(currentIdx + 1, total);

    //     // aplicar active apenas no próximo
    //     $slider.find('li').removeClass('active');
    //     var $next = $baseItems.filter('[data-slick-index="'+nextIdx+'"]').first();
    //     if($next.length){
    //         $next.addClass('active');
    //         var $link = $next.find('a').first();
    //         if($link.length){ $link.trigger('click'); } else { $next.trigger('click'); }
    //     }

    //     // mover slick apenas se houver 5 ou mais itens (para evitar movimentar com poucos thumbs)
    //     if($slider.hasClass('slick-initialized') && total >= 5){
    //         var slick = $slider.slick('getSlick');
    //         var $cloneTarget = $(slick.$slides).filter('[data-slick-index="'+nextIdx+'"]').first();
    //         if($cloneTarget.length){
    //             var goTo = $cloneTarget.index();
    //             slick.slickGoTo(goTo);
    //         } else {
    //             slick.slickNext();
    //         }
    //     }
    // });

    // $(document).on('click', '.custom-prev-arrow', function(e){
    //     e.preventDefault();
    //     var $slider = $('#photo-list');
    //     if(!$slider.length) return;
    //     var $baseItems = getBaseItems($slider);
    //     if(!$baseItems.length) return;
    //     var total = $baseItems.length;
    //     var $current = $baseItems.filter('.active').first();
    //     var currentIdx = parseInt($current.attr('data-slick-index'), 10);
    //     if(isNaN(currentIdx)) currentIdx = 0;
    //     var prevIdx = normalizeIndex(currentIdx - 1, total);

    //     // aplicar active apenas no anterior
    //     $slider.find('li').removeClass('active');
    //     var $prev = $baseItems.filter('[data-slick-index="'+prevIdx+'"]').first();
    //     if($prev.length){
    //         $prev.addClass('active');
    //         var $link = $prev.find('a').first();
    //         if($link.length){ $link.trigger('click'); } else { $prev.trigger('click'); }
    //     }

    //     // mover slick apenas se houver 5 ou mais itens (para evitar movimentar com poucos thumbs)
    //     if($slider.hasClass('slick-initialized') && total >= 5){
    //         var slick = $slider.slick('getSlick');
    //         var $cloneTarget = $(slick.$slides).filter('[data-slick-index="'+prevIdx+'"]').first();
    //         if($cloneTarget.length){
    //             var goTo = $cloneTarget.index();
    //             slick.slickGoTo(goTo);
    //         } else {
    //             slick.slickPrev();
    //         }
    //     }
    // });
})